export const API_BASE_URL = 'https://stockholdergame.com/stockholdergame'
